const TIMER_KEY = 'selluxe_cart_timer'; // Key for localStorage
const DEFAULT_TIMER = 900; // Default timer in seconds
let activeInterval = null; // Active interval reference

function formatTime(seconds) {
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}

function getTimerElement() {
  // Dynamically fetch the timer element in case of re-renders
  return document.getElementById('cart-timer');
}

function startCountdown(duration) {
  const endTime = Date.now() + duration * 1000;
  localStorage.setItem(TIMER_KEY, endTime);

  if (activeInterval) clearInterval(activeInterval); // Clear any existing interval

  activeInterval = setInterval(() => {
    const timerElement = getTimerElement();
    if (!timerElement) return; // If the element doesn't exist, do nothing

    const remainingTime = Math.max(0, Math.floor((endTime - Date.now()) / 1000));

    if (remainingTime <= 0) {
      clearInterval(activeInterval);
      activeInterval = null;
      timerElement.textContent = formatTime(DEFAULT_TIMER); // Reset display
    } else {
      timerElement.textContent = formatTime(remainingTime); // Update timer display
    }
  }, 1000);
}

function pauseTimer() {
  if (activeInterval) {
    clearInterval(activeInterval);
    activeInterval = null;
  }
  localStorage.removeItem(TIMER_KEY); // Remove saved timer when paused
  const timerElement = getTimerElement();
  if (timerElement) timerElement.textContent = formatTime(DEFAULT_TIMER); // Reset display
}

function initializeTimer() {
  const savedEndTime = localStorage.getItem(TIMER_KEY);
  const currentTime = Date.now();

  if (savedEndTime && savedEndTime > currentTime) {
    startCountdown(Math.floor((savedEndTime - currentTime) / 1000));
  } else {
    const timerElement = getTimerElement();
    if (timerElement) timerElement.textContent = formatTime(DEFAULT_TIMER); // Reset display
  }
}

function manageCartTimer() {
  const cartItems = document.querySelectorAll('#CartDrawer-Form .cart-item');

  if (cartItems.length > 0) {
    const savedEndTime = localStorage.getItem(TIMER_KEY);
    const currentTime = Date.now();

    if (!savedEndTime || savedEndTime <= currentTime) {
      // Start a new timer if no valid saved timer exists
      startCountdown(DEFAULT_TIMER);
    } else if (!activeInterval) {
      // Resume the timer if paused
      startCountdown(Math.floor((savedEndTime - currentTime) / 1000));
    }
  } else {
    pauseTimer(); // Pause the timer if the cart is empty
  }
}

// Initialize timer on page load
document.addEventListener('DOMContentLoaded', () => {
  initializeTimer();

  // Check cart items every second
  setInterval(manageCartTimer, 1000);
});
